import React, { useMemo, useState } from 'react';
import { Button, Modal, Typography, message } from 'antd';
import { CodeOutlined, CopyOutlined } from '@ant-design/icons';
import {
  buildDynamicApiResponseExample,
  getDynamicApiSchemaHint,
} from 'utils/metaFlowComponents';

const { Text, Paragraph } = Typography;

const DynamicApiResponseHint = ({ componentType, dataSourceKey }) => {
  const [open, setOpen] = useState(false);

  const example = useMemo(
    () => buildDynamicApiResponseExample(componentType, dataSourceKey),
    [componentType, dataSourceKey]
  );

  if (!example) {
    return null;
  }

  const json = JSON.stringify(example, null, 2);
  const hint = getDynamicApiSchemaHint(componentType);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(json);
      message.success('Copied to clipboard');
    } catch {
      message.error('Could not copy');
    }
  };

  return (
    <>
      <Button
        type="link"
        size="small"
        icon={<CodeOutlined />}
        onClick={() => setOpen(true)}
        style={{ padding: 0, height: 'auto', fontSize: 12, marginTop: 4 }}
      >
        View expected API response
      </Button>

      <Modal
        title="Expected endpoint response (Meta format)"
        open={open}
        onCancel={() => setOpen(false)}
        footer={[
          <Button key="copy" icon={<CopyOutlined />} onClick={handleCopy}>
            Copy JSON
          </Button>,
          <Button key="close" type="primary" onClick={() => setOpen(false)}>
            Close
          </Button>,
        ]}
        width={560}
      >
        <Paragraph type="secondary" style={{ fontSize: 12, marginBottom: 12 }}>
          Return this shape from your customer endpoint on <Text code>INIT</Text> or{' '}
          <Text code>data_exchange</Text>. Waba forwards the request as plain JSON; map your
          database fields into Meta&apos;s keys before responding.
        </Paragraph>
        {hint ? (
          <Paragraph style={{ fontSize: 12, marginBottom: 12 }}>{hint}</Paragraph>
        ) : null}
        <pre
          style={{
            margin: 0,
            padding: 12,
            background: '#f5f5f5',
            borderRadius: 8,
            fontSize: 11,
            lineHeight: 1.5,
            overflow: 'auto',
            maxHeight: 360,
          }}
        >
          {json}
        </pre>
      </Modal>
    </>
  );
};

export default DynamicApiResponseHint;
